import { render, staticRenderFns } from "./ppbkl.vue?vue&type=template&id=2d6dad3b&scoped=true"
import script from "./ppbkl.vue?vue&type=script&lang=js"
export * from "./ppbkl.vue?vue&type=script&lang=js"
import style0 from "./ppbkl.vue?vue&type=style&index=0&id=2d6dad3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6dad3b",
  null
  
)

export default component.exports